export function getStartPageUrl(language) {
  switch (language) {
    case 'sv':
    case 'de':
    case 'no':
    case 'da':
    case 'en':
    default:
      return 'https://app.adjust.com/112zb57z_116hd4yn'
  }
}
